import React from "react"
import styles from "./message.module.scss"
import {combineClasses} from "../../util/class-utils"

type MessageType = "info" | "alert" | "success" | "error"

interface MessageProps {
  type: MessageType
  personalData?: boolean
  spaceBelow?: boolean
  className?: string
}

const ClassNames: { [type in MessageType]: string } = {
  info: styles.Info,
  alert: styles.Alert,
  success: styles.Success,
  error: styles.Error
}

export const Message: React.FC<MessageProps> = ({type, personalData = false, spaceBelow, className, children}) => {
  const classNames = combineClasses([ClassNames[type], spaceBelow ? styles.SpaceBelow : undefined, className])
  return (
    <div className={classNames} data-hj-suppress={personalData}>
      {children}
    </div>
  )
}
